import { faDiagramProject, faTrash, faUser, faUserAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function UserListItem({ title, createdAt, updatedAt, description, onClick, icon }) {
  return (
    <div onClick={onClick} className='flex bg-white mb-1 hover:bg-gray-400 cursor-pointer shadow-sm border-2 border-zinc-200 text-black py-4 px-5'>
        <div className='flex justify-center items-center bg-theme/80 text-zinc-200 pl-5 pr-5 mr-5'>
            <FontAwesomeIcon size='1x' icon={faUser} />
        </div>
        <div className='w-full'>
             <div className='text-sm uppercase flex justify-between'>
              {title}
              <FontAwesomeIcon icon={faTrash} color='red' size='1x' />
             </div>
           
             <div className='text-xs'>
              <div className='flex justify-between mt-2'>
                <div className='capitalize'>Date added: {createdAt}</div>
                <div className='capitalize'>Last modification date: {updatedAt}</div>
              </div>
             </div>
        </div>
    </div>
  )
}
